module.exports = {
  theme: {
    screens: {
      sm: '640px',
      md: '768px',
      lg: '1024px',
      xl: '1280px',
    },
    colors: {
      transparent: 'transparent',
      primary: {
        '01': 'var(--colors-primary-01)',
        '02': 'var(--colors-primary-02)',
        '03': 'var(--colors-primary-03)',
      },
      secondary: {
        '01': 'var(--colors-secondary-01)',
        '02': 'var(--colors-secondary-02)',
        '03': 'var(--colors-secondary-03)',
      },
      tertiary: {
        '01': 'var(--colors-tertiary-01)',
        '02': 'var(--colors-tertiary-02)',
      },
      brand: {
        '01': 'var(--colors-brand-01)',
        '02': 'var(--colors-brand-02)',
        '03': 'var(--colors-brand-03)',
      },
      info: {
        '01': 'var(--colors-info-01)',
        '02': 'var(--colors-info-02)',
      },
      error: {
        '01': 'var(--colors-error-01)',
        '02': 'var(--colors-error-02)',
      },
      success: {
        '01': 'var(--colors-success-01)',
        '02': 'var(--colors-success-02)',
      },
      warning: {
        '01': 'var(--colors-warning-01)',
        '02': 'var(--colors-warning-02)',
      },
      support: {
        '01': 'var(--colors-support-01)',
        '02': 'var(--colors-support-02)',
        '03': 'var(--colors-support-03)',
        '04': 'var(--colors-support-04)',
        '05': 'var(--colors-support-05)',
        '06': 'var(--colors-support-06)',
        '07': 'var(--colors-support-07)',
        '08': 'var(--colors-support-08)',
        '09': 'var(--colors-support-09)',
        10: 'var(--colors-support-10)',
        11: 'var(--colors-support-11)',
        12: 'var(--colors-support-12)',
        13: 'var(--colors-support-13)',
        14: 'var(--colors-support-14)',
        15: 'var(--colors-support-15)',
        16: 'var(--colors-support-16)',
        17: 'var(--colors-support-17)',
        18: 'var(--colors-support-18)',
        19: 'var(--colors-support-19)',
        20: 'var(--colors-support-20)',
        21: 'var(--colors-support-21)',
        22: 'var(--colors-support-22)',
        23: 'var(--colors-support-23)',
        24: 'var(--colors-support-24)',
        25: 'var(--colors-support-25)',
        26: 'var(--colors-support-26)',
        27: 'var(--colors-support-27)',
        28: 'var(--colors-support-28)',
        29: 'var(--colors-support-29)',
      },
      neutral: {
        '01': 'var(--colors-neutral-01)',
        '02': 'var(--colors-neutral-02)',
        '03': 'var(--colors-neutral-03)',
        '04': 'var(--colors-neutral-04)',
        '05': 'var(--colors-neutral-05)',
        '06': 'var(--colors-neutral-06)',
        '07': 'var(--colors-neutral-07)',
        '08': 'var(--colors-neutral-08)',
        '09': 'var(--colors-neutral-09)',
      },
      disabled: {
        '01': 'var(--colors-disabled-01)',
        '02': 'var(--colors-disabled-02)',
        '03': 'var(--colors-disabled-03)',
        '04': 'var(--colors-disabled-04)',
      },
    },
    backgroundColor: (theme) => ({
      ...theme('colors'),
      '01': 'var(--colors-background-01)',
      '02': 'var(--colors-background-02)',
      '03': 'var(--colors-background-03)',
    }),
    fontFamily: {
      sans: 'var(--fonts-sans)',
    },
    fontSize: {
      xs: '0.75rem',
      sm: '0.875rem',
      md: '1rem',
      lg: '1.125rem',
      xl: '1.25rem',
      '2xl': '1.625rem',
      '3xl': '1.875rem',
      '4xl': '2.25rem',
      '5xl': '3rem',
      '6xl': '3.75rem',
    },
    fontWeight: {
      regular: '400',
      semibold: '600',
      bold: '700',
    },
    borderRadius: {
      none: '0',
      sm: '0.25rem',
      md: '0.625rem',
      lg: '1.25rem',
      full: '9999px',
    },
    extend: {
      spacing: {
        18: '4.5rem',
        22: '5.5rem',
        27: '6.75rem',
        'screen-sm': '640px',
        'screen-md': '768px',
        'screen-lg': '992px',
        'screen-xl': '1280px',
      },
      minWidth: (theme) => ({
        ...theme('spacing'),
      }),
      opacity: {
        15: "0.15",
        25: "0.25",
        35: "0.35",
        45: "0.45",
        55: "0.55",
        65: "0.65",
        75: "0.75",
        85: "0.85",
        95: "0.95",
      }
    },
  },
}
